import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '~/constants';
import moment from 'moment';

import ButtonBase from "@material-ui/core/ButtonBase";
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import Icon from '@material-ui/core/Icon';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import awsconfig from '~/awsconfig';
import fetch from '~/utils/fetch';

import EnhancedTable from '~/widgets/table-enhanced'
import LinkButton from '~/widgets/button-link'
import ChipDetails from '~/widgets/chip-details'

const ActionsMenu = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        console.log('buttonbase onClick!')
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        console.log('handleClose!');
        e.stopPropagation();
        setAnchorEl(null);
    };

    const global_sign_out = async () => {
        try {
            props.dispatch({type: actionTypes.SPINNING_START});
            let response = await fetch({
                url: `${awsconfig.officeApi}/users/${props.user._id}/admin-global-signout`,
                data: {},
                method: 'post',
            })
            props.dispatch({
                type: actionTypes.SNACKBAR,
                snackbar: {
                    severity: 'success',
                    text: `User refresh tokens revoked. Any access tokens will remain valid until their regular expiry time.`
                }
            });
        } catch (e) {
            console.error(e)
            props.dispatch({
                type: actionTypes.SNACKBAR,
                snackbar: {
                    severity: 'error',
                    text: e.message
                }
            });
        } finally {
            props.dispatch({type: actionTypes.SPINNING_STOP})
        }
    }

    const reset_password_or_new_account_action = () => {
        if(props.user.onboarded !== true){
            return (
                <MenuItem onClick={async e=>{
                    handleClose(e);
                    try {
                        props.dispatch({type: actionTypes.SPINNING_START});
                        let response = await fetch({
                            url: `${awsconfig.officeApi}/users/${props.user._id}/resend-new-account-email`,
                            data: {},
                            method: 'post',
                        })
                        console.log(response);
                        props.dispatch({
                            type: actionTypes.SNACKBAR,
                            snackbar: {
                                severity: 'success',
                                text: `Sent the New Account email to ${props.user.email}.`
                            }
                        });
                    } catch (e) {
                        console.error(e)
                        props.dispatch({
                            type: actionTypes.SNACKBAR,
                            snackbar: {
                                severity: 'error',
                                text: e.message
                            }
                        });
                    } finally {
                        props.dispatch({type: actionTypes.SPINNING_STOP})
                    }
                }}>
                    <ListItemIcon>
                        <Icon>email</Icon>
                    </ListItemIcon>
                    <ListItemText
                        inset={false}
                        primary="Send New Account Email"
                        secondary="Re-send the New Account user registration email"
                    />
                </MenuItem>
            )
        }
        return (
            <MenuItem onClick={async e=>{
                handleClose(e);
                try {
                    props.dispatch({type: actionTypes.SPINNING_START});
                    let response = await fetch({
                        url: `${awsconfig.officeApi}/users/${props.user._id}/admin-reset-password-email`,
                        data: {},
                        method: 'post',
                    })
                    console.log(response);
                    props.dispatch({
                        type: actionTypes.SNACKBAR,
                        snackbar: {
                            severity: 'success',
                            text: `Sent Reset Password email to ${props.user.email}.`
                        }
                    });
                } catch (e) {
                    console.error(e)
                    props.dispatch({
                        type: actionTypes.SNACKBAR,
                        snackbar: {
                            severity: 'error',
                            text: e.message
                        }
                    });
                } finally {
                    props.dispatch({type: actionTypes.SPINNING_STOP})
                }
            }}>
                <ListItemIcon>
                    <Icon>email</Icon>
                </ListItemIcon>
                <ListItemText
                    inset={false}
                    primary="Send Reset Password Email"
                    secondary="Send an email to force the user to reset their password"
                />
            </MenuItem>
        )
    }

    return (
        <React.Fragment>
            <ButtonBase
                className="button button-clear"
                onClick={handleClick}
            >
                Actions
            </ButtonBase>
            <Menu
                anchorEl={anchorEl}
                key={props.user._id}
                open={Boolean(anchorEl)}
                keepMounted={true}
                className="user-actions"
                autoFocus={false}
                variant='selectedMenu'
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                disableScrollLock={true}
            >
                <MenuItem onClick={e=>{
                    console.log(props)
                    handleClose(e);
                    props.history.push(`/app/departments/${props.match.params.department_id}/users/${props.user._id}`)
                }}>
                    <ListItemIcon>
                        <Icon>pageview</Icon>
                    </ListItemIcon>
                    <ListItemText
                        inset={false}
                        primary="View User"
                        secondary="View the Office user account"
                    />
                </MenuItem>
                <MenuItem onClick={e=>{
                    handleClose(e);
                    window.open(`https://citadel.virtualclaimsadjuster.com/contacts/rep/viewRep.asp?pid=${props.user.vcaInternalRep}`)
                }}>
                    <ListItemIcon>
                        <Icon>launch</Icon>
                    </ListItemIcon>
                    <ListItemText
                        inset={false}
                        primary="Open in VCA"
                        secondary="View the Claim Rep in Virtual Claims Adjuster"
                    />
                </MenuItem>
                <MenuItem onClick={e=>{
                    handleClose(e);
                    global_sign_out();
                }}>
                    <ListItemIcon>
                        <Icon>phonelink_erase</Icon>
                    </ListItemIcon>
                    <ListItemText
                        inset={false}
                        primary="Global Sign Out"
                        secondary="Revoke all devices' refresh tokens"
                    />
                </MenuItem>
                {reset_password_or_new_account_action()}
            </Menu>
        </React.Fragment>
    )
}

export default class Container extends Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render() {
        // console.log(this.props);
        // console.log(this.state);

        if(!this.props.departments.is_loaded){
            return ''  // hide while loading
        }

        let table = '';
        let users = this.props.department.users || [];
        table = (
            <EnhancedTable
                data={users.map(user=>{
                    let activeOnboardedStatus = 'Active';
                    if(!user.active){
                        activeOnboardedStatus = 'Disabled by Admin';
                    }
                    if(!user.onboarded){
                        activeOnboardedStatus = 'Not Onboarded';
                    }
                    if(!user.onboardingEmailSent){
                        activeOnboardedStatus = 'No Email Sent'
                    }
                    if(!user.cognitoEnabled){
                        activeOnboardedStatus = 'Cognito Disabled'
                    }
                    return {
                        ...user,
                        activeOnboardedStatus: activeOnboardedStatus,
                        fullname: `${user.lastname}, ${user.firstname}`
                    }
                })}
                order='desc'
                orderBy='createdAt'
                rowsPerPage={10}
                rowClickHandler={(e, r)=>{
                    e.preventDefault();
                    console.log('rowClickHandler!')
                    console.log(e.isDefaultPrevented());
                    console.log(e.isPropagationStopped());
                    console.log(e);
                    this.props.history.push(`/app/departments/${this.props.match.params.department_id}/users/${r._id}`)
                }}
                columns={[
                  {id: 'vcaInsurerId', label: 'VCA #' },
                  {id: 'name', label: 'Badge #' },
                  {id: 'fullname', label: 'Name' },
                  {id: 'email', label: 'Email' },
                  {id: 'createdAt', label: 'Created'},
                  {id: 'activeOnboardedStatus', label: 'Status' },
                  // {id: `cognitoEnabled`, label: 'Cognito Enabled' },
                  // {id: `cognitoConfirmed`, label: 'Cognito Confirmed' },
                  // {id: `cognitoEmailVerified`, label: 'Email Verified' },
                  {id: 'role', label: 'Role' },
                  {id: 'undefined', label: 'Actions'}
                ]}
                buildTableRow={user=>{
                    const renderCognitoLabel = (value, labelTrue, labelFalse, labelUndefined) => {
                        switch (value){
                            case true:
                                return labelTrue;
                            case false:
                                return labelFalse;
                            default:
                                return labelUndefined;
                        }
                    };
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>
                                <ChipDetails
                                    label={`${user.vcaInternalRep || 'PENDING'}`}
                                    status={user.active ? 'success' : 'error'}
                                    tooltip={user.active ? 'Active' : 'Inactive'}
                                />
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>{user.badgeNumber}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{user.fullname}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{user.email}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{moment(user.createdAt).format('MMM Do, YYYY')}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{user.activeOnboardedStatus}</EnhancedTable.Cell>
                            {/*
                            <EnhancedTable.Cell>
                                {renderCognitoLabel(user.cognitoEnabled, 'Enabled', 'DISABLED', '(No Cognito user.)')}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {renderCognitoLabel(user.cognitoConfirmed, 'Confirmed', 'UNCONFIRMED', '(No Cognito user.)')}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                {renderCognitoLabel(user.cognitoEmailVerified, 'Verified', 'Not Verified', '(No Cognito user.)')}
                            </EnhancedTable.Cell>
                            */}
                            <EnhancedTable.Cell>
                                {user.role}
                            </EnhancedTable.Cell>
                            <EnhancedTable.Cell>
                                <ActionsMenu user={user} dispatch={this.props.dispatch} history={this.props.history} match={this.props.match}/>
                            </EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        )

        return (
            <React.Fragment>
                {table}
            </React.Fragment>
        )
    }
}
